import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getIncidents(companyId, query) {

	return dataTransferWrap(
		ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].getIncidents,
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}
function getIncidentPreview(companyId,incidentId, data) {
	return dataTransferWrap(
		ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].getIncidentPreview,
		{
			urlParams: {
				companyId,
				incidentId,
			},
			...data
		},
	)
}
function getIncidentPopup(companyId,incidentId, data) {
	return dataTransferWrap(
		ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].getIncidentPopup,
		{
			urlParams: {
				companyId,
				incidentId,
			},
			...data
		},
	)
}

function createIncident(companyId,data) {
	return dataTransferWrap(ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].createIncident, {
		urlParams: {
			companyId,
		},
		...data
	})
}

function getIncident(companyId,incidentId, query) {
	return dataTransferWrap(ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].getIncident, {
		urlParams: {
			companyId,
			incidentId,
		},
    params: query,
	})
}

function patchIncident(companyId,incidentId, data) {
	return dataTransferWrap(ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].patchIncident, {
		urlParams: {
			companyId,
			incidentId,
		},
		...data,
	})
}
function patchIncidentClose(companyId,incidentId, data) {
	return dataTransferWrap(ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].patchIncidentClose, {
		urlParams: {
			companyId,
			incidentId,
		},
		...data,
	})
}

function putIncident(companyId,incidentId, data) {
	return dataTransferWrap(ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].putIncident, {
		urlParams: {
			companyId,
			incidentId,
		},
		...data,
	})
}

function deleteIncident(companyId,incidentId) {
	return dataTransferWrap(ModulesMap.INCIDENTS,dtConfig[ModulesMap.INCIDENTS].deleteIncident, {
		urlParams: {
			companyId,
			incidentId,
		},
	})
}

export default {
	getIncidents,
	getIncidentPopup,
	getIncidentPreview,
	getIncident,
	patchIncident,
  patchIncidentClose,
	putIncident,
	createIncident,
	deleteIncident,
}
